import { render, staticRenderFns } from "./FinancialCollection.vue?vue&type=template&id=6dcf7f82&scoped=true&"
import script from "./FinancialCollection.vue?vue&type=script&lang=js&"
export * from "./FinancialCollection.vue?vue&type=script&lang=js&"
import style0 from "./FinancialCollection.vue?vue&type=style&index=0&id=6dcf7f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf7f82",
  null
  
)

export default component.exports